/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Data Access Rule effect.
*/
export enum AccessConditionEffect {
  RULE_EFFECT_INCLUSIVE = 'INCLUSIVE',
  RULE_EFFECT_EXCLUSIVE = 'EXCLUSIVE'
}
